// import createPersistedState from 'vuex-persistedstate'
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    menu: []
  },
  // plugins: [createPersistedState()],
  getters,
  mutations,
  actions
};
